import React from "react";
import styles from './AirlineLogoImg.module.scss';

interface IAirlineLogoImgProps {
  icao: string;
  title?: string;
  alt?: string;
  style: any;
  onError?: any;
  className?: string;
}


const AirlineLogoImg = ({icao, title, alt, style, onError, className}: IAirlineLogoImgProps) => {
  return (
    <img
      className={[styles.airlineLogoImg, className].filter(s => s).join(" ")}
      src={`/img/airlines/${icao}.png`}
      referrerPolicy="no-referrer"
      alt={alt || title}
      title={title || alt}
      onError={onError}
      style={{

        ...style
      }}
      loading="lazy"
    />
  );
};

AirlineLogoImg.defaultProps = {
  title: '',
  alt: '',
  style: {},
  onError: () => {
  },
};

export default React.memo(AirlineLogoImg);
